import React, { Suspense, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";


import ScrollProgress from "./Components/common/ScrollProgress";
import FloatingSocialButtons from "./Components/common/FloatingSocialButtons";
import ChatBot from "./Components/FixedButton/ChatBot";
import ThankYouPage from "./Components/ThankYouPage/ThankYouPage";
import PopUp from "./Components/PopUp/PopUp";
import Modal from "./Components/Navbar/Modal";

import {Blogs,BlogOne,BlogTwo,BlogThree,BlogFour,BlogFive,BlogSix,BlogSeven,BlogEight,BlogNine,PanelBlog} from "./Components/Blogs/index"
import { ItContractpage, Servicepage, WebAppPage, MobileApp, ServerlessAppPage, CloudDevopsPage, QaTestingPage, DedicatedTeams, NewProductDevelopment, DigitalTransformation, AiConsultation } from "./pages/solutions";
import { Manufacturing, Industrypage, Healthcare, Startup, Ecommerce, Datacenter, Fintech, Banking, SMEs } from "./pages/industry";
import Loader from "./Components/common/Loader";

const Navbar=React.lazy(()=>import('./Components/Navbar/Navbar'))
const Footer=React.lazy(()=>import('./Components/Footer/Footer'))
const Home=React.lazy(()=>import('./Home/Home'))
const Privacy= React.lazy(()=>import('./Components/Privacy/Privacy'))
const Casestudies = React.lazy(() => import("./pages/Casestudies"));
const CaseStudyDetails = React.lazy(() => import("./pages/CaseStudyDetails"));
 
const Contact = React.lazy(() => import("./pages/Contact"));
const ErrorPage=React.lazy(()=>import('./Components/ErrorPage/ErrorPage'))

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // window.scrollTo(0, 0);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    })
  }, [pathname]);
}


const App = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [targetedElement, setTargetedElement] = useState("");

  const openModal = () => {
    setIsModalOpen(true);
  };

  // useEffect(() => {
  //   const chatbotTimeout = setTimeout(() => {
  //     // Trigger the chatbot to open after 3 seconds
  //     document.getElementById("chatbot-toggle-button").click();
  //   }, 1000);
  //   return () => clearTimeout(chatbotTimeout);
  // }, []);





  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <title>ExxonInfo</title>
          <meta
            name="description"
            content="Welcome to the ExxonInfo, Where we redefine IT staffing to meet the evolving needs of your business. With a commitment to excellence and a proven track record, we stand as your reliable partner in acquiring top-tier IT talent"
          />
          <meta
            name="keywords"
            content="web application development,web designer,	
          IT company,	
          IT services,	
          IT support,"
          />
          <meta name="author" content="ExxonInfo ITstaffing" />
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <meta name="language" content="English" />
          <link rel="canonical" href="https://exxoninfo.com/" />
          <link
            rel="sitemap"
            type="application/xml"
            title="Sitemap"
            href="https://exxoninfo.com/sitemap.xml"
          />
        </Helmet>

        <Router>
          <ScrollToTop />
          <Navbar
            openModal={openModal}
            setTargetedElement={setTargetedElement}
          />
          <ScrollProgress />
          <Suspense fallback={<Loader />}>
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  targetedElement={targetedElement}
                />
              }
            />
            <Route path="/services" element={<Servicepage />} />
            <Route path="/services/it-contract-staffing" element={<ItContractpage />} />
            <Route path="/services/web-app" element={<WebAppPage />} />
            <Route path="/services/mobile-app" element={<MobileApp />} />
            <Route path="/services/serverless-app" element={<ServerlessAppPage />} />
            <Route path="/services/cloud-devops" element={<CloudDevopsPage />} />
            <Route path="/services/qa-testing" element={<QaTestingPage />} />
            <Route path="/services/dedicated-teams" element={<DedicatedTeams />} />

            <Route path="/product-development" element={<NewProductDevelopment />} />
            <Route path="/product-development/digital-transformation" element={<DigitalTransformation />} />
            <Route path="/product-development/ai-it-consultation" element={<AiConsultation />} />

            <Route path="/industries" element={<Industrypage />} />
            <Route path="/industries/manufacturing" element={<Manufacturing />} />
            <Route path="/industries/healthcare" element={<Healthcare />} />
            <Route path="/industries/startup" element={<Startup />} />
            <Route path="/industries/e-commerce" element={<Ecommerce />} />
            <Route path="/industries/data-centers" element={<Datacenter />} />
            <Route path="/industries/fintech" element={<Fintech />} />
            <Route path="/industries/banking" element={<Banking />} />
            <Route path="/industries/small-medium-enterprises" element={<SMEs />} />


            <Route path="/case-studies" element={<Casestudies />} />
            <Route path="/case-studies/:id" element={<CaseStudyDetails />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/blog" element={<Blogs />} />
            <Route
              path="/blog/utilizing-Contract-workers"
              element={<BlogOne />}
            />
            <Route path="/blog/exxon-info's-guide" element={<BlogTwo />} />
            <Route
              path="/blog/revolutionizing-contractual-hiring"
              element={<BlogThree />}
            />
            <Route path="/blog/top-seven-it-staffing" element={<BlogFour />} />
            <Route
              path="/blog/top-ten-programming-language"
              element={<BlogFive />}
            />
            <Route
              path="/blog/Offshore-Staff-Augmentation"
              element={<BlogNine />}
            />
            <Route path="/blog/:blogsName" element={<PanelBlog />} />
            <Route path="/blog/hiring-IT-Team" element={<BlogSix />} />
            <Route path="/blog/empowering-global" element={<BlogSeven />} />
            <Route
              path="/blog/accelerating-global-business"
              element={<BlogEight />}
            />
            <Route path="/thankyou" element={<ThankYouPage />} />
            <Route path="*" element={<ErrorPage />} />
            <Route path="/contact" element={<PopUp></PopUp>}></Route>
            <Route path="/shcedulecall" element={<Modal />} />
            <Route path="/privacypolicy" element={<Privacy />} />
          </Routes>
          </Suspense>
          <Footer />
        </Router>
        <ChatBot autoOpen={true} />
      </HelmetProvider>
      <FloatingSocialButtons />
    </div>
  );
};

export default App;
